import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import ClienteMenuLateral from './ClienteMenuLateral';
import { AgendamentosService } from '../../../services/api/Agendamentos/AgendamentosService';
import { dateDbToBr, float2moeda } from '../../../utils/Funcoes';
import { Col, Form, Row, Table, Button } from 'react-bootstrap';
import { tiposAgendamentosUtils } from '../../../utils/tiposAgendamentosUtils';
import { tiposServicosUtils } from '../../../utils/tiposServicosUtils';
import { statusAgendamentosUtils } from '../../../utils/statusAgendamentosUtils';
import PaginacaoLinks from '../../../components/Paginacao/PaginacaoLinks';
import { ProfissionaisService } from '../../../services/api/Profissionais/ProfissionaisService';
import { DayPilot } from '@daypilot/daypilot-lite-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';


const ClientesAgendamentos = () => {

    const { idCliente } = useParams()
    const [listAgendamento, setlistAgendamentos] = useState([])
    const [filtro, setFiltro] = useState(null)
    const [listProfissional, setListProfissional] = useState([])
    const [showFiltrar, setShowFiltrar] = useState(false)

    const [paginacao, setPaginacao] = useState({
        currentPage: null,
        totalPages: null,
        nextPage: null,
        prevPage: null

    })



    const fetchAgendamento = async (page) => {


        const dataIni = (filtro?.dataHoraIni != null) ? filtro?.dataHoraIni : null;
        const dataFim = (filtro?.dataHoraFim != null) ? filtro?.dataHoraFim : null;
        const dadosFiltro = {
            ...filtro,
            clientesId: idCliente,
            withAgendamentosItens: true,
            paginate: true,
            page: (page != undefined) ? page : null
        }
        const data = await AgendamentosService.getAll(dataIni, dataFim, dadosFiltro)

        if (data.success) {
            setlistAgendamentos(data.data.data)
            setPaginacao({
                currentPage: data.data.current_page,
                totalPages: Math.ceil(data.data.total / data.data.per_page),
                nextPage: (data.data.current_page + 1),
                prevPage: (data.data.current_page - 1)
            })
        }

    }

    const fetchProfissionais = async () => {
        const data = await ProfissionaisService.getAll()
        if (data.success) {
            setListProfissional(data.data)
        }
    }

    const onChangeFiltro = (e) => {
        switch (e.target.name) {
            case 'dataHoraIni':
                setFiltro({
                    ...filtro,
                    dataHoraIni: e.target.value
                })
                break;
            case 'dataHoraFim':
                setFiltro({
                    ...filtro,
                    dataHoraFim: e.target.value
                })
                break;
            case 'profissional':
                setFiltro({
                    ...filtro,
                    profissionaisId: e.target.value
                })
                break;
            case 'status':
                setFiltro({
                    ...filtro,
                    statusId: e.target.value
                })
                break;
        }

    }

    const handleFiltrar = async () => {
        await fetchAgendamento()
    }
    
    const handleLimparFiltro = async (somenteFechar) => {
        setShowFiltrar(false)
        console.log(somenteFechar)
        if (somenteFechar) {
            setFiltro({
                dataHoraIni: '',
                dataHoraFim: '',
                profissionaisId: '',
                status: ''
            })
            fetchAgendamento()
        }
    }


    useEffect(() => {
        fetchAgendamento()
        fetchProfissionais()
    }, [])


    const getStatusTag = (item) => {
        const status = statusAgendamentosUtils().find(tp => tp.id == item)
        return <span className={'tag '} style={{ background: status?.color }}>{status?.nome}</span>;
    }
    const getTipoServico = (item) => {
        const status = tiposServicosUtils().find(tp => tp.id == item)
        return <span className={'tag '}>{status?.nome}</span>;
    }

    const onClickPage = async (page) => {
        await fetchAgendamento(page)
    }
    console.log(filtro)
    return (
        <>
            <ClienteMenuLateral idCliente={idCliente}>
                <h4 className='text-primary mb-15'>Agendamentos  <Button
                    style={{ display: (showFiltrar) ? 'none' : '' }}
                    variant='info' size='sm' className='mr-15' title='Filtrar' onClick={() => setShowFiltrar(true)}><FontAwesomeIcon icon={faFilter} /></Button>
                </h4>

                <div className='box-fundo mb-15' style={{ display: (showFiltrar) ? '' : 'none' }}>

                    <h5 className='text-primary'>Filtro</h5>
                    <Row>
                        <Col>
                            <Form.Label>Data</Form.Label>
                            <Form.Control
                                name="dataHoraIni"
                                type='date'
                                onChange={(e) => onChangeFiltro(e)}
                                value={filtro?.dataHoraIni}
                            ></Form.Control>
                        </Col>
                        <Col>
                            <Form.Label>Data Fim</Form.Label>
                            <Form.Control
                                name="dataHoraFim"
                                type='date'
                                value={filtro?.dataHoraFim}
                                onChange={(e) => onChangeFiltro(e)}></Form.Control>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Label>Profissional</Form.Label>

                            <Form.Select
                                name="profissional"
                                onChange={(e) => onChangeFiltro(e)}
                                value={filtro?.profissionaisId}
                            >
                                <option value="">Todos</option>
                                {listProfissional?.map((item) => (
                                    <option value={item.id}>{item.nome}</option>
                                ))}

                            </Form.Select>
                        </Col>
                        <Col>
                            <Form.Label>Status</Form.Label>
                            <Form.Select
                                name="status"
                                value={filtro?.statusId}
                                onChange={(e) => onChangeFiltro(e)}

                            >
                                <option value="">Todos</option>
                                {statusAgendamentosUtils().map((item) => (
                                    <option value={item.id}>{item.nome}</option>
                                ))}
                            </Form.Select>
                        </Col>
                    </Row>
                    <br></br>
                    <div className="text-center">
                        <Button variant='secondary' size="sm" className='mr-15' onClick={() => handleLimparFiltro(true)}>Limpar </Button>
                        <Button variant='danger' size="sm" className='mr-15' onClick={() => handleLimparFiltro(false)}>Fechar </Button>
                        <Button variant='success' size="sm" onClick={() => handleFiltrar()}>Filtrar </Button>
                    </div>
                </div>
                <div className='box-fundo'>
                    <div className='table-responsive'>
                        <table className='table table-hover'>

                            <thead>
                                <tr>
                                    <th>Data</th>
                                    <th>Animal</th>
                                    <th>Serviço</th>
                                    <th>Profissional</th>
                                    <th>Observações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {listAgendamento?.map((item) => (
                                    <>
                                        <tr>
                                            <td>
                                                <div className='mb-10'>
                                                    {(item?.inicio !== null) &&
                                                        `${dateDbToBr(item.inicio.substring(0, 10))} às  ${item?.inicio.substring(11, 16)}h`}
                                                </div>
                                                {
                                                    getStatusTag(item?.status)
                                                }

                                            </td>
                                            <td>
                                                {(item?.animais != null) &&
                                                    <>
                                                        {item?.animais?.nome}
                                                    </>
                                                }
                                            </td>
                                            <td>
                                                {getTipoServico(item?.tiposServicosId)}

                                                <div className='mb-10'>
                                                    {item?.agendamento_itens?.map((agServ) => (
                                                        <>
                                                            {(agServ.qnt > 1 && agServ.qnt + 'x ')}
                                                            {agServ.nomeServico}<br></br>
                                                            {float2moeda(agServ.valorServico * agServ.qnt)}
                                                        </>
                                                    ))}
                                                </div>

                                            </td>
                                            <td>

                                                {item?.profissionais?.nome}
                                            </td>
                                            <td>{item?.observacoes}</td>
                                        </tr>

                                    </>
                                ))}


                            </tbody>
                        </table>

                        <PaginacaoLinks totalPages={paginacao?.totalPages}
                            currentPage={paginacao?.current_page}
                            onClickPage={onClickPage}
                        ></PaginacaoLinks>
                    </div>
                </div>

            </ClienteMenuLateral>

        </>
    )
}

export default ClientesAgendamentos;